var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AgencyService } from './../api/agency.service';
import { OnInit, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OpenModalService } from './shared/modals/open-modal.service';
import { BaseComponent } from './base-component';
var PartnersBaseComponent = /** @class */ (function (_super) {
    __extends(PartnersBaseComponent, _super);
    function PartnersBaseComponent(injector, agencyService, route, openModalService) {
        var _this = _super.call(this, injector) || this;
        _this.agencyService = agencyService;
        _this.route = route;
        _this.openModalService = openModalService;
        return _this;
    }
    PartnersBaseComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.data.forEach(function (data) {
            _this.validateRouteDataParams(data, ['partners']);
            _this.partners = data.partners;
        });
        this.setTitle('Parteneri ' + this.agencyService.agency.name);
    };
    PartnersBaseComponent.prototype.openPartnerModal = function (partner) {
        this.openModalService.showPartnersContent(partner);
    };
    return PartnersBaseComponent;
}(BaseComponent));
export { PartnersBaseComponent };



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/partners-base.component.ts.pre-build-optimizer.js